import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

export default function EmployeesList({ onView, onEdit, onAdd }) {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("All");
  const navigate = useNavigate();

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const snapshot = await getDocs(collection(db, "EMPLOYEES"));
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEmployees(data);
    } catch (err) {
      console.error("Error fetching employees:", err);
    } finally {
      setLoading(false);
    }
  };

  const counts = {
    All: employees.length,
    Regular: employees.filter(emp => (emp.category || "Regular") === "Regular").length,
    Contract: employees.filter(emp => emp.category === "Contract").length
  };

  const filteredEmployees = activeTab === "All"
    ? employees
    : employees.filter(emp => (emp.category || "Regular") === activeTab);

  return (
    <div className="container-fluid mt-4 px-4">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-bold text-dark mb-0">Employees List</h3>
            <button
              className="btn btn-primary shadow-sm"
              onClick={() => onAdd ? onAdd() : navigate("/employees/add")}
            >
              <i className="bi bi-plus-lg me-1"></i> Add Employee
            </button>
          </div>

          {/* Status Tabs */}
          <ul className="nav nav-tabs mb-4">
            {["All", "Regular", "Contract"].map(cat => (
              <li className="nav-item" key={cat}>
                <button
                  className={`nav-link ${activeTab === cat ? 'active' : ''}`}
                  onClick={() => setActiveTab(cat)}
                >
                  {cat} ({counts[cat]})
                </button>
              </li>
            ))}
          </ul>

          <div className="table-responsive">
            <table className="table table-bordered table-striped table-hover">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Employee ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Designation</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmployees.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4 text-muted">No {activeTab.toLowerCase()} employees found</td>
                  </tr>
                ) : (
                  filteredEmployees.map((emp, index) => (
                    <tr key={emp.id}>
                      <td>{index + 1}</td>
                      <td>{emp.accid}</td>
                      <td>
                        <span
                          className="text-primary fw-medium"
                          style={{ cursor: "pointer", textDecoration: "none" }}
                          onClick={() => onView ? onView(emp.id) : navigate(`/employees/view/${emp.id}`)}
                        >
                          {emp.name}
                        </span>
                      </td>
                      <td>{emp.mobile}</td>
                      <td>{emp.designation}</td>
                      <td>
                        <span className={`badge ${emp.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                          {emp.status}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary me-2"
                          onClick={() => onEdit ? onEdit(emp.id) : navigate(`/employees/edit/${emp.id}`)}
                          title="Edit"
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
